module.exports = __webpack_public_path__ + "static/img/company-ethics-imgfull-1.ae7dccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-ethics-imgfull-1.jpg
// module id = J8WA
// module chunks = 0